import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { fetchGroupContact } from 'actions/Contact/Group';
import {
  DateField,
  InputField,
  Button,
} from '@unite-us/app-components';
import today from 'common/utils/today';
import { required } from 'src/common/form/utils/rffValidations';
import Header from './Header';
import searchContact from '../actions/SearchContact';
import retrieveSearchedContacts from '../actions/RetrieveSearchedContacts';
import retrieveSelectedContact from '../actions/RetrieveSelectedContact';

class Search extends Component {
  static handleEnter(e) {
    if (e.key === 'Enter') {
      const searchRecordsButton = document.getElementById('search-records-btn');
      if (searchRecordsButton) {
        searchRecordsButton.focus();
      }
    }
  }

  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', Search.handleEnter);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', Search.handleEnter);
  }

  onSubmit(formData, form) {
    return this.props.searchContact(this.props.groupId, formData)
      .then((response) => this.props.onComplete(response.data.data, formData, () => {
        if (this.props.resetAfterSubmit) {
          form.reset();
        }
      }));
  }

  render() {
    const {
      header,
      mainHeader,
      subHeader,
      className,
      initialValues,
    } = this.props;
    return (
      <div {...(className ? { className } : {})}>
        <Header
          header={header}
          mainHeader={mainHeader}
          subHeader={subHeader}
        />
        <Form onSubmit={this.onSubmit} initialValues={initialValues}>
          {({ handleSubmit, pristine, submitting }) => (
            <form className="row" onSubmit={handleSubmit}>
              <div className="col-md-6">
                <Field name="first_name" validate={required}>
                  {(params) => (
                    <InputField
                      {...params}
                      label="First Name"
                      id="first-name"
                      inline={false}
                      required
                    />
                  )}
                </Field>
              </div>
              <div className="col-md-6">
                <Field name="last_name" validate={required}>
                  {(params) => (
                    <InputField
                      {...params}
                      label="Last Name"
                      id="last-name"
                      inline={false}
                      required
                    />
                  )}
                </Field>
              </div>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4">
                    <Field name="date_of_birth" validate={required}>
                      {(params) => (
                        <DateField
                          {...params}
                          id="date-of-birth"
                          inline={false}
                          label="Date of Birth"
                          maxDate={today()}
                          required
                        />
                      )}
                    </Field>
                  </div>
                </div>
              </div>
              <footer className="col-md-12 referral-footer">
                <Button
                  id="search-records-btn"
                  className="search-records-btn"
                  onClick={handleSubmit}
                  label="Search Our Records"
                  primary
                  disabled={pristine || submitting}
                  style={{ float: 'right' }}
                  type="submit"
                />
              </footer>
            </form>
          )}
        </Form>
      </div>
    );
  }
}

Search.propTypes = {
  className: PropTypes.string,
  fetchGroupContact: PropTypes.func.isRequired,
  groupId: PropTypes.string,
  header: PropTypes.string.isRequired,
  initialValues: PropTypes.object,
  mainHeader: PropTypes.string,
  onComplete: PropTypes.func.isRequired,
  resetAfterSubmit: PropTypes.bool,
  retrieveSearchedContacts: PropTypes.func.isRequired,
  retrieveSelectedContact: PropTypes.func.isRequired,
  searchContact: PropTypes.func.isRequired,
  searchedContacts: PropTypes.array.isRequired,
  subHeader: PropTypes.string.isRequired,
};

Search.defaultProps = {
  className: '',
  groupId: null,
  mainHeader: null,
  initialValues: {},
  resetAfterSubmit: false,
};

function mapStateToProps(state) {
  const { session: { groupId }, searchedContacts } = state;
  return {
    groupId,
    searchedContacts,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchGroupContact,
    retrieveSearchedContacts,
    retrieveSelectedContact,
    searchContact,
  },
)(Search);
